package it.neckar.lizergy.model.financial.quote

import it.neckar.commons.tags.Tag
import it.neckar.commons.tags.Tags
import it.neckar.commons.tags.toTagsOrEmpty
import it.neckar.lizergy.model.financial.currency.PriceWithProfit
import it.neckar.lizergy.model.financial.currency.ValueAddedTax
import it.neckar.open.unit.other.pct
import it.neckar.uuid.randomForEnvironment
import kotlin.uuid.Uuid

/**
 * Builder for an item
 */
@QuoteDsl
class QuoteItemBuilder(
  var uuid: Uuid = Uuid.randomForEnvironment(),

  /**
   * The (bold) headline
   */
  var headline: String,

  var priceForOneElement: PriceWithProfit,

  /**
   * The amount
   */
  var amount: Amount = Amount(1),

  var factor: @pct Double = 1.0,

  var relevance: Tags,

  var visibility: Visibility,

  var optionality: Optionality,

  var valueAddedTax: ValueAddedTax,

  var details: String? = null,

  ) : QuoteElementBuilder {

  constructor(
    uuid: Uuid = Uuid.randomForEnvironment(),
    headline: String,
    priceForOneElement: PriceWithProfit,
    amount: Amount = Amount(1),
    factor: @pct Double = 1.0,
    relevance: Tag,
    visibility: Visibility,
    optionality: Optionality,
    valueAddedTax: ValueAddedTax,
    details: String? = null,
  ) : this(
    uuid = uuid,
    headline = headline,
    priceForOneElement = priceForOneElement,
    amount = amount,
    factor = factor,
    relevance = relevance.toTagsOrEmpty(),
    visibility = visibility,
    optionality = optionality,
    valueAddedTax = valueAddedTax,
    details = details,
  )

  /**
   * Marks this element as optional
   */
  @QuoteDsl
  fun optional() {
    optionality = Optionality.Optional
  }

  override fun build(): QuoteItem {
    return QuoteItem(
      uuid = uuid,
      headline = headline,
      details = details,
      priceForOneElement = priceForOneElement,
      amount = amount,
      factor = factor,
      visibility = visibility,
      relevance = relevance,
      optionality = optionality,
      valueAddedTax = valueAddedTax,
    )
  }
}

/**
 * Creates a [QuoteItemBuilder]
 */
fun quoteItem(
  headline: String,
  priceForOneElement: PriceWithProfit,

  amount: Double,

  factor: @pct Double,

  /**
   * Optional: Only applied if not null
   */
  relevance: Tags,
  /**
   * optional parameter that is only applied if set
   */
  visibility: Visibility,

  optionality: Optionality,

  valueAddedTax: ValueAddedTax,
  /**
   * The configuration
   */
  config: QuoteItemBuilder.() -> Unit = {},
): QuoteItemBuilder {
  return QuoteItemBuilder(
    headline = headline,
    priceForOneElement = priceForOneElement,
    amount = Amount(amount),
    factor = factor,
    relevance = relevance,
    visibility = visibility,
    optionality = optionality,
    valueAddedTax = valueAddedTax,
  ).also(config)
}

fun quoteItem(headline: String, priceForOneElement: PriceWithProfit, amount: Double, factor: @pct Double, relevance: Tag, visibility: Visibility, optionality: Optionality, valueAddedTax: ValueAddedTax, config: QuoteItemBuilder.() -> Unit = {}): QuoteItemBuilder {
  return quoteItem(headline, priceForOneElement, amount, factor, relevance.toTagsOrEmpty(), visibility, optionality, valueAddedTax, config)
}
